import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import { mergeClasses } from '@fluentui/react-components';
import { NoData } from './components/no-data';
import { useStyles } from './styles/chart';
import { IFluctuationsChartProps } from './types/types';
import { useChartViewOptions } from './chart-data/chart-view-options';

const ChartView = React.memo(({
  isLoading, size, chartProps, Chart, i18n,
}: { classes: any, isLoading: boolean, size: 'small' | 'medium' | 'large', chartProps: any, i18n: any, Chart: any }) => {
  if (isLoading) {
    return <NoData i18n={i18n} isLoading size={size} />;
  }

  if (chartProps?.hasChartData) {
    return <Chart {...chartProps} />;
  }

  return <NoData i18n={i18n} size={size} />;
});

export function FluctuationsChart(props: IFluctuationsChartProps) {
  const classes = useStyles();
  const {
    TimeZone,
    performanceTimeSeries,
    isLoading = false,
    size,
    i18n,
  } = props;

  const metricType = performanceTimeSeries?.MetricName;
  const chartProps = useChartViewOptions({
    i18n,
    metricType,
    performanceTimeSeries,
    TimeZone,
  });

  return (
    <div className={mergeClasses('ba-fluctuations-chart-fluent-v2__chart', classes.chartContainer)}>
      <ChartView
        classes={classes}
        isLoading={isLoading}
        size={size}
        chartProps={chartProps}
        Chart={HighchartsReact}
        i18n={i18n}
      />
    </div>
  );
}
